var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import Button from "@mui/material/Button";
import SaveIcon from "@material-ui/icons/Save";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import {MuiThemeProvider } from '@material-ui/core/styles';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import { muiThemeDesign } from '../../mui-theme-design';
import moment from "moment";
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Fade from '@mui/material/Fade';
import { makeStyles } from "@mui/styles";
import Checkbox from '@mui/material/Checkbox';
import {logger,checkAuthentication,muiLoaderOptions} from '../../utils';
const ExcelJS = require('exceljs');


const pageStyles = makeStyles(theme => ({
    container: {
        border: '1px ridge #9e9e9e',
        borderRadius: '5px',
        display: 'inline-flex',
        
    },
    item: { borderRadius: '10px' },
    paper: {
        textAlign: 'center',
    },
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden",
            color: '#ffffff'
        },
        "& .Mui-checked": {
            color: '#ffffff'
        },
        "& .MuiCheckBox-root": {
            color: '#ffffff'
        },
        
    }
}));

export default function RateTableReport(props) {
    const [refresh, setRefresh] = React.useState(false);
   // const [dataSet, setDataSet] = React.useState([]);
    const [SOWList, setSOWList] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [status, setStatus] = React.useState(false);
    const [expand, setExpand] = React.useState(true);
    const [PositionList, setPositionList] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
/*    var unique = {
        SOWID: [],
        SOW: [],
        AbrvSOW: [],
        MGPT: [],
        Positions: []
    };*/
    const classes = pageStyles();

/*    const getRateTables = async () => {
        await fetch('api/Reports/UserRoles', {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => setDataSet(json));
        logger(dataSet);
    };*/

    const columns = [
        {
            name: "SOW",
            label: "SOW",
            options: {
                filter: true,
                filterType: "dropdown",
             //   filterOptions: {
             //       renderValue: v => v.AbbrvSOW
             //   },
                sort: true,
                setCellProps: value => {
                    return {
                        style: {
                            borderBottom: '2px solid #1976d2',
                            verticalAlign: 'top',
                            width: '40%'
                        },
                    }
                },
                  sortCompare: (order) => {
                      return ({ SOWList: SOW }, { SOWList: AbbrvSOW }) => {
                          return (parseInt(a) - parseInt(b)) * (order === "asc" ? 1 : -1);
                      };
                  },
                customBodyRender: (value, meta) => {
                    const record = SOWList[meta.currentTableData[meta.rowIndex].index];
                    logger(`sow column`, record)
                    return (

                        <Box>
                            <Grid container direction='column'>
                                <Grid item>
                                    {record.SOW} 
                                </Grid>
                                <Grid item style={{ paddingLeft: 10, verticalAlign: 'top', fontSize: '0.7rem', height: '15px' }}>
                                    ({record.AbrvSOW}) -- {record.MGPT}
                                </Grid>
                                <Grid item>
                                    {moment.utc(record.StartDate).format("MM/DD/YYYY")} - {moment.utc(record.EndDate).format("MM/DD/YYYY")}
                                </Grid>
                            </Grid>
                        </Box>

                    )

                },
            }
        },
        

        {
            name: "Position",
            label: "Positions",
            options: {
                filter: false,
                sort: true,
                setCellProps: value => {
                    return {
                        style: {
                            borderBottom: '2px solid #1976d2',                           
                             width: '50%'
                        },
                    }
                },
                customBodyRender: (value, meta) => {

                   /* unique.SOWID = [...new Set(dataSet.map(item => item.SOWID))];
                    unique.SOW = [...new Set(dataSet.map(item => item.SOW))];
                    unique.AbrvSOW = [...new Set(dataSet.map(item => item.AbrvSOW))];
                    unique.MGPT = [...new Set(dataSet.map(item => item.MGPT))];
                    logger (`unique`, unique)*/
                    const currentSOW = SOWList[meta.currentTableData[meta.rowIndex].index];
                  //  logger(`in PositionsRender`, meta.rowIndex, `--`, currentSOW)
                  //  logger(`in column PL-`, PositionList) 
                    var choices = [];
                    /*unique.SOWID.forEach(item => {*/ 
                    PositionList.forEach(choice => {
                    //    logger(`currentSOW`, currentSOW)
                     //   logger(`SOWCheck  `, choice.SOWID, `--`, currentSOW.SOWID)
                        if (choice.SOWID === currentSOW.SOWID) {
							const byteArray = new Uint8Array(choice.Rate.data);
							const textDecoder = new TextDecoder();
							const res = textDecoder.decode(byteArray);
							const r = parseFloat(res).toFixed(2);	                                
                            choices.push({ SOWID: choice.SOWID, Position: choice.Position, AbrvName: choice.AbrvName, Rate: r , DiscRate: choice.DiscRate })
                        }
                    })
                   /* unique.Positions.push({ choices })
                    })*/
                    logger(`positions`, choices)
                    let USDollar = new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD',
                    });
                    //  logger(`render-`, p.Position, `--`, p.Rate)
                  /*  logger(`unique-complete`, unique)*/
                    return (

                        <Grid container className={classes.container} >
                            <Box style={{ width: '100%', borderBottom: '1px solid #1976d2' }} >
                                <Grid container item xs={12} wrap='nowrap' justifyContent='flex-start' >
                                    <Grid container wrap='nowrap' item xs={6}>
                                        <Grid item xs={6} style={{ paddingTop: 10, width: '300px', paddingLeft: 20 }} >Position</Grid>
                                    </Grid>
                                    <Grid container item xs={12} style={{ paddingTop: 10 }}>
                                        <Grid item xs={3} style={{ paddingTop: 10, paddingLeft: 20 }} >Raw Rate </Grid>
                                        <Grid item xs={3} style={{ paddingTop: 10, paddingLeft: 20 }} >Disc Rate </Grid>
                                        <Grid item xs={12} > </Grid>
                                    </Grid>
                                </Grid>
                            </Box>
                            {choices.map((p, index) => {
                                return (
                                    
                                    <Box style={{ width: '100%', borderBottom: '1px solid #1976d2' }} >
                                        <Grid container item xs={12} wrap='nowrap'  >
                                            <Grid container wrap='nowrap' item xs={6} direction='column' >
                                                <Grid item xs={6} style={{ width: '300px', paddingLeft: 5}} >{p.Position}</Grid>
                                                <Grid item xs={6} style={{ paddingLeft: 10, verticalAlign: 'top', fontSize: '0.7rem', height: '15px' }} >({p.AbrvName}) </Grid>
                                            </Grid>
                                            <Grid container item xs={12} style={{ paddingTop: 10, paddingLeft: 20 }}>
                                                <Grid item xs={3} >
                                                  {USDollar.format(p.Rate)}
                                                 </Grid> 
                                                <Grid item xs={3} style={{ paddingLeft: 20 }} >
                                                    {USDollar.format(p.DiscRate)}
                                                </Grid> 
                                         </Grid>
                                         </Grid>
                                        </Box>
                                )
                            })}
                        </Grid>
                    )

                }
            }
        },

        
        
        
       /* {
            name: "Rate",
            label: "Rate",
            options: {
                filter: true,
                sort: true,
                //    position: "sticky",
            }
        },*/

    ];
 
    const MakeToolbar = () => {
        return (
            <>
                <Tooltip title="show inactive SOW">
                    <Checkbox defaultChecked={!expand} color="default" onClick={() => { setSOWList([]); setExpand(!expand), setRefresh(true); }} />
                </Tooltip>  
            </>
        );
        logger("createTB" + MakeToolbar)
    }

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('rowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('rowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();

    const options = {
    filter: true,
    filterType: 'dropdown',
    responsive: 'vertical',
    fixedHeader: true,
    fixedSelectColumn: false,
    tableBodyHeight: "400px",
    tableBodyMaxHeight: "1000px",
    responsive: 'standard',
    selectableRows: 'none',
    rowsPerPage: initialRowsPerPage,
    rowsPerPageOptions: [10, 20, 50, 100],
    textLabels: {
        toolbar: {
            search: "Search",
            downloadCsv: "Download Excel",
            print: "Print",
            viewColumns: "View Columns",
            filterTable: "Filter Table",
        },
    },
    customToolbar: () => <MakeToolbar />,
    onDownload: (buildHead, buildBody, columns, data) => {
        const customBuildHead = () => {
            var newColumns = columns.map(column => column.label);
            newColumns.push("Rate");
            newColumns.push("Discount Rate");
            return newColumns;
        };

        Array.prototype.insert = function(index, ...items) {
            this.splice(index, 0, ...items);
        };

    
 const customBuildBody = () => {
    var choices = [];
    var uniqueSOWs = new Set();

    SOWList.forEach(sow => {
        var sowFound = false;

        PositionList.forEach(choice => {
            if (choice.SOWID === sow.SOWID) {
                const byteArray = new Uint8Array(choice.Rate.data);
                const textDecoder = new TextDecoder();
                const res = textDecoder.decode(byteArray);
                const r = parseFloat(res).toFixed(2);

                var combinedData = {
                    "SOW": sowFound ? "" : sow.SOW,
                    "Positions": choice.Position,
                    "Rate": r,
                    "Discount Rate": choice.DiscRate.toFixed(2)
                };

                choices.push(combinedData);
                uniqueSOWs.add(sow.SOW);
                sowFound = true;
            }
        });

        if (!sowFound) {
            // Add an entry with SOW, but empty position, rate, and discount rate
            var emptyData = {
                "SOW": sow.SOW,
                "Positions": "",
                "Rate": "",
                "Discount Rate": ""
            };

            choices.push(emptyData);
            uniqueSOWs.add(sow.SOW);
        }
    });

    return choices;
};


        const headers = customBuildHead();
        const rows = customBuildBody();

        // Create a new Excel Workbook
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet 1');

        // Add headers
        const headerRow = worksheet.addRow(headers);
        headerRow.font = { bold: true };

        // Add rows
        rows.forEach(row => {
            const newRow = worksheet.addRow(Object.values(row));
            
            worksheet.columns.forEach(col => {
			const headerLength = col.headers.length;
			const maxColumnWidth = col.values.reduce((maxWidth, value) => {
				if (value && value.length > maxWidth) {
					return value.length;
				}
				return maxWidth;
			}, 0);
			col.width = Math.max(headerLength, maxColumnWidth);
		});
        });

        // Generate the Excel file
        workbook.xlsx.writeBuffer().then(buffer => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'SowRateTable.xlsx';
            a.click();
        });

        return false;
    }
};


        
    const handleClickOpen = () => {

        setRefresh(true)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setExpand(true);
    };

    const getRates = async () => {
        logger(`in getRates`)
        await fetch(`api/Reports/RateTables/${expand}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                setPositionList(json)
                logger(`PositionList`, json)
            })
    }
    const getSOWS = async () => {
        logger(`in getSOWS`)
        await fetch(`api/Reports/SOWList/${expand}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                setSOWList(json)
                logger(`SOWS`,SOWList)
                setIsLoading(false);
            })
        getRates();
        setRefresh(false)
    }
   /* const dialogDisplay = () => {
        if (!status) {
            if (open) {
                //    logger(`in fail-wait`)
                return (
                    <Box sx={{ height: 300 }}>
                        <Fade
                            in={(!status)}
                            style={{
                                transitionDelay: status ? '800ms' : '0ms',
                            }}
                            unmountOnExit
                        >
                            <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row" justifyContent="center">
                                <CircularProgress color="secondary" />
                                <CircularProgress color="success" />
                                <CircularProgress color="inherit" />
                            </Stack>
                        </Fade>
                    </Box>
                )
            }
        } else {
            return (
                <Box>
                    <MUIDataTable className={classes.root}
                        title={

                            <Typography variant="h6" style={{ color: "white" }}>
                                <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close"> <CloseIcon /> </IconButton>
                                Rate Tables
                            </Typography>
                        }
                        data={SOWList}
                        columns={columns}
                        options={options}
                    />
                </Box>
            )
        }
    }*/

    React.useEffect(() => {
		checkAuthentication();

        if (refresh) {
        //    logger ("expand" + expand)
           /* fetch(`api/Reports/RateTables/${expand}`)
                .then(res => res.json())
                .then(json => setDataSet(json))
          //      .then (json => listPositions())
            logger(dataSet);*/
            logger(`in refresh`)
            if (!SOWList.length) {
                getSOWS();
            }
            //if (PositionList.length) {
              //  setStatus(true)
                setRefresh(false)
            //}

              //  setRefresh(false);
            
        }

    })

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (
        <div className={classes.root}>
            <Button variant="contained" onClick={handleClickOpen}>
                Rate Tables
            </Button>
            <MuiThemeProvider theme={muiThemeDesign}>
                <Dialog className={classes.root} open={open} onClose={handleClose} fullWidth maxWidth="1400px" scroll="paper" overflow-y="hidden">
                <DialogContent >

                       <Box>
                    <MUIDataTable className={classes.root}
                        title={

                            <Typography variant="h6" style={{ color: "white" }}>
                                <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close"> <CloseIcon /> </IconButton>
                                Rate Tables
                            </Typography>
                        }
                        data={isLoading ? [] :SOWList}
                        columns={columns}
                        options={muiLoaderOptions(options, isLoading)}
                    />
                </Box>


                </DialogContent>
                </Dialog>
            </MuiThemeProvider>
        </div>
    );
}
